"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var observation_windows_1 = require("../../../common/helpers/observation-windows");
var signature_roster_1 = require("../../../common/helpers/signature-roster");
var StudentDrivesViewController = /** @class */ (function () {
    function StudentDrivesViewController($state, UsersModel, driveSession, FlashService, student, locations, cancellationRules, DrivesModel) {
        var _this = this;
        this.$state = $state;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.cancellationRules = cancellationRules;
        this.DrivesModel = DrivesModel;
        this.studentSigned = false;
        this.user = student;
        this.driveSession = driveSession;
        this.updatePickupLocation = this.updatePickupLocation.bind(this);
        this.driveIsInThePast = this.driveIsInThePast.bind(this);
        this.parseInt = this.parseInt.bind(this);
        this.saveSignature = this.saveSignature.bind(this);
        this.studentCanEditPickupLocation =
            this.driveSession.type.allow_custom_pickup_locations &&
                !this.driveIsInThePast() &&
                this.driveSession.observation === false;
        this.studentCanEditDropoffLocation =
            this.driveSession.type.allow_custom_dropoff_locations &&
                !this.driveIsInThePast() &&
                this.driveSession.observation === false;
        this.myWindow = null;
        if (this.driveSession.observation === true) {
            this.driveSession.type.name =
                this.driveSession.type.name + " (Observation)";
            this.myWindow = (0, observation_windows_1.personalWindow)(this.driveSession, this.user.id);
        }
        var pickupLocations = structuredClone(locations.pickuplocations);
        var dropofflocations = structuredClone(locations.dropofflocations);
        if (this.driveSession.pickuplocation) {
            pickupLocations.push(this.driveSession.pickuplocation);
        }
        if (this.driveSession.dropofflocation) {
            dropofflocations.push(this.driveSession.dropofflocation);
        }
        pickupLocations = (0, uniqBy_1.default)(pickupLocations, "id");
        dropofflocations = (0, uniqBy_1.default)(dropofflocations, "id");
        pickupLocations.forEach(function (location) {
            if (location.id === _this.driveSession.pickuplocation.id) {
                _this.driveSession.pickuplocation = location;
            }
        });
        dropofflocations.forEach(function (location) {
            if (_this.driveSession.dropofflocation.hasOwnProperty("id") &&
                location.id === _this.driveSession.dropofflocation.id) {
                _this.driveSession.dropofflocation = location;
            }
        });
        pickupLocations.map(function (location) {
            location.name = location.name + " - " + location.address.street;
            return location;
        });
        dropofflocations.map(function (location) {
            location.name = location.name + " - " + location.address.street;
            return location;
        });
        var start = (0, time_1.parseDate)(this.driveSession.drive_date + " " + this.driveSession.start_time);
        this.allowCancellation =
            this.driveSession.status !== "Complete" && (0, time_1.isAfter)(start, new Date());
        this.pickuplocations = pickupLocations;
        this.dropofflocations = dropofflocations;
    }
    /**
     * Do not allow students to change pick up or drop off locations within 24 hours of the session start time
     * @returns {boolean}
     */
    StudentDrivesViewController.prototype.studentAllowedToChangePickupLocation = function () {
        var timeUntilSessionStarts = (0, time_1.differenceInMinutes)((0, time_1.parseDate)(this.driveSession.drive_date + " " + this.driveSession.start_time), new Date());
        return timeUntilSessionStarts >= 1440;
    };
    StudentDrivesViewController.prototype.driveIsInThePast = function () {
        return (0, time_1.isBefore)((0, time_1.parseDate)(this.driveSession.drive_date + " " + this.driveSession.start_time), new Date());
    };
    StudentDrivesViewController.prototype.parseInt = function (number) {
        return parseInt(number, 10);
    };
    /**
     * Whether to prompt this student to sign the completed lesson. The roster
     * answers it per passenger: an observation lesson carries a row for each
     * student in the car, so the driver signing no longer clears the observers'
     * prompt the way "does this lesson have any student signature" did.
     */
    StudentDrivesViewController.prototype.showSignaturePad = function () {
        var _this = this;
        return (this.driveSession.status === "Complete" &&
            !this.studentSigned &&
            (this.driveSession.signature_roster || []).some(function (row) {
                return row.signee_type === "student" &&
                    row.student_id === _this.user.id &&
                    row.status === "awaiting";
            }));
    };
    StudentDrivesViewController.prototype.saveSignature = function (signature) {
        var _this = this;
        this.DrivesModel.submitDriveSignature(this.driveSession.id, signature, "student").then(function (response) {
            _this.studentSigned = true;
            _this.driveSession.signature_roster = (0, signature_roster_1.markRosterRowSigned)(_this.driveSession.signature_roster, function (row) {
                return row.signee_type === "student" && row.student_id === _this.user.id;
            }, signature);
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        }, function () {
            _this.FlashService.setMessage({
                type: "danger",
                message: "We were unable to save your signature. Please try again or contact your driving school.",
            });
        });
    };
    StudentDrivesViewController.prototype.updatePickupLocation = function () {
        var _this = this;
        this.submitted = true;
        if (!this.studentAllowedToChangePickupLocation()) {
            return this.FlashService.setMessage({
                type: "danger",
                message: "You may only update a session pick-up location or drop-off location up to twenty four " +
                    "hours before it begins. If you need them to be changed call your driving school.",
            });
        }
        // this.driveSession.session_length info into minutes
        this.driveSession.session_length =
            parseInt(this.driveSession.sessionLengthHours, 10) * 60 +
                parseInt(this.driveSession.sessionLengthMinutes, 10);
        var payload = {
            id: this.driveSession.id,
            pickuplocation: this.driveSession.pickuplocation,
            dropofflocation: this.driveSession.dropofflocation,
        };
        this.UsersModel.updateStudentDrivePickupLocation(payload).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.submitted = false;
            _this.$state.go("drivecoach.student.upcoming", {}, { reload: true });
        });
    };
    return StudentDrivesViewController;
}());
StudentDrivesViewController.$inject = [
    "$state",
    "UsersModel",
    "driveSession",
    "FlashService",
    "student",
    "locations",
    "cancellationRules",
    "DrivesModel",
];
exports.default = StudentDrivesViewController;
